import { Avatar, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from 'constants/theme';
import { Modal } from 'react-bootstrap';

export const ModalStyle = styled(Modal)(({ theme }) => ({
  '.modal-content': {
    maxWidth: 1646,
    margin: 'auto',
    borderRadius: 10,
    backdropFilter: 'saturate(1) blur(40px)',
    backgroundColor: colors.white90,
    '.modal-body': {
      hegiht: 'fit-content'
    }
  },

}))

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  color: colors.textPrimary,
  [theme.breakpoints.up('sm')]: {
    fontSize: 18,
  }
}))

export const TitlePayment = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  padding: '4px 10px 4px 10px',
  backgroundColor: colors.themeSecondColor10,
  color: colors.textPrimary,
  [theme.breakpoints.up('sm')]: {
    fontSize: 18,
  }
}))

export const CustomField = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'start',
  marginLeft: 'auto',
  '.MuiButtonBase-root': {
    backgroundColor: 'transparent !important',
    transition: 'transform .15s ease',
    '&.icon-expanded.disabled': { opacity: 0.5 },
    '&.isExpanded': {
      transform: 'rotate(-180deg)'
    }
  },
  '.MuiTextField-root': {
    width: 160,
    [theme.breakpoints.down('xs')]: {
      width: 95,
    }
  }
}))

export const SummaryNetPrice = styled(Box)(({ theme }) => ({
  backgroundColor: colors.white,
  border: `1px solid ${colors.lightGray}`,
  borderRadius: 4,
  '> div': {
    width: '50%',
    minHeight: 96,
  },
  [theme.breakpoints.down('sm')]: {
    '> div': {
      minHeight: 67,
    }
  }
}))

export const FooterStepButton = styled(Box)(({ theme }) => ({
  '> div': {
    margin: '0 !important',
    width: '100%',
    '&:first-of-type': {
      marginRight: '4px !important'
    },
    '&:last-of-type': {
      marginLeft: '4px !important'
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 72,
      '&:first-of-type': {
        marginRight: '8px !important'
      },
      '&:last-of-type': {
        marginLeft: '8px !important'
      },
    }
  },
  '.MuiButton-root': {
    width: '100%',
    height: 44,
    fontSize: 16,
    '&.MuiButton-outlined': {
      backgroundColor: colors.white
    }
  }
}))

export const FooterPaymentButton = styled(Box)(({ theme }) => ({
  '> div': {
    margin: '0 !important',
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      textAlign: 'center'
    }
  },
  '.MuiButton-root': {
    width: '100%',
    height: 44,
    fontSize: 16,
    '&.MuiButton-outlined': {
      backgroundColor: colors.white
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 544,
      margin: 'auto'
    }
  }
}))
export const ProfileAvatar = styled(Avatar)(({ theme }) => ({
  width: 49,
  height: 49,
  [theme.breakpoints.up('xs')]: {
    width: 56,
    height: 56
  }
}))

export const Balance = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  [theme.breakpoints.down('sm')]: {
    fontSize: 14,
  }
}))

export const ChannelBox = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  borderRadius: 4,
  border: `1px solid ${colors.lightGray}`,
  backgroundColor: colors.white,
  height: 96,
  paddingLeft: 10,
  paddingRight: 10,
  textAlign: 'center',
  '.MuiTypography-root': {
    color: colors.disabledGray
  },
  'p.channel-name': {
    width: '90%',
  },
  '&.active': {
    border: `5px solid ${colors.themeSecondColor}`,
    position: 'relative',
    '.MuiTypography-root': {
      color: colors.themeSecondColor
    }
  },
  '&.disabled': {
    cursor: 'not-allowed',
    backgroundColor: colors.lightGray,
    opacity: 0.6,
    pointerEvents: 'none',
    '.MuiTypography-root': {
      color: colors.disabledGray
    }
  },
  '& .number': {
    position: 'absolute',
    top: 0,
    left: 0,
    minWidth: 24,
    minHeight: 24,
    color: colors.white,
    background: colors.themeSecondColor,
    borderRadius: '0px 0 20px',
    padding: '0px 0 0 6px',
    fontSize: 14,
    lineHeight: 'normal'
  },
  [theme.breakpoints.down('sm')]: {
    svg: {
      width: 'auto',
      height: 30
    }
  },
  [theme.breakpoints.down('xs')]: {
    margin: '0 1px',
    height: 44,
    outline: `1px solid ${colors.lightGray}`,
    border: '3px solid transparent',
    svg: {
      height: 20
    },
    '&.active': {
      border: `3px solid ${colors.themeSecondColor}`,
      outline: `1px solid transparent`
    }
  }
}))


export const ButtonBank = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  borderRadius: 4,
  border: `2px solid ${colors.lightGray}`,

  img: {
    borderRadius: 4,
    height: 30,
    width: 30,
    objectFit: 'cover'
  },
  '&.active': {
    boxShadow: `0 0 6px 0 ${colors.themeSecondColor}`,
    borderColor: colors.themeSecondColor
  }
}))

export const TypographyBankNumber = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  [theme.breakpoints.up('sm')]: {
    fontSize: 16
  }
}))